import { Route } from '@angular/router';
import { authenticationGuard } from '@ps-gui/shared-core';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('@ps-gui/claims-terminal-classification').then((m) => m.classificationRoutes),
    canActivate: [authenticationGuard],
  },
];
